import api from '../services/ApiService';

export const GET_PAGE = 'GET_PAGE';
export const REQUEST_PAGE = 'REQUEST_PAGE';
export const UNMOUNT_PAGE = 'UNMOUNT_PAGE';
export const TOGGLE_FULLSCREEN = 'TOGGLE_FULLSCREEN';

export function getPage(pageName) {
  return {
    type: GET_PAGE,
    payload: (async () => {
      return {
        pageConfig: (await api.get(`/page/${pageName}`)).data,
        attachments: (await api.get(`/page/${pageName}/attachments`)).data,
      };
    })(),
    meta: {
      pageName,
    },
  };
}

export function requestPage(pageName) {
  return {
    type: REQUEST_PAGE,
    pageName,
  };
}

export function unmountPage(pageName) {
  return {
    type: UNMOUNT_PAGE,
    pageName,
  };
}

export function toggleFullscreen(fullscreen) {
  return {
    type: TOGGLE_FULLSCREEN,
    fullscreen,
  };
}
